import {
  SET_UPDATING_EMAIL_AND_PASSWORD,
  UPDATE_COOKIE_CONSENT,
  CookieConsentValue,
} from '../reducers/types/Settings.d';

export const setUpdatingEmailAndPassword = (payload: boolean): any => {
  return {
    type: SET_UPDATING_EMAIL_AND_PASSWORD,
    payload,
  };
};

export const updateCookieConsentValue = (payload: CookieConsentValue): any => {
  return {
    type: UPDATE_COOKIE_CONSENT,
    payload,
  };
};
